module.exports = __webpack_public_path__ + "img/login-bg.6a8d5f9e.jpg";